export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}

export const enum FinscanEntity{
    POLICY_HOLDER = 'POLICY_HOLDER',
    FREIGHT_FORWARDER_CLIENT = 'FREIGHT_FORWARDER_CLIENT',
    LOSS_PAYEE_BANK = 'LOSS_PAYEE_BANK',
    LOSS_PAYEE_OTHER = 'LOSS_PAYEE_OTHER',
    SURVEY_AGENTS = 'SURVEY_AGENTS',
    VESSELS = 'VESSELS',
    STORAGES ='STORAGES',
}

export interface IFinscanOpportunityDto {
    id?: string;
    finscanEntity?: string;
    enableContinuousMonitoring?: boolean,
    enableAdHocMonitoring?:boolean,
    enableSanctionScreening?: boolean,
    finscanEntityName?: string;
}



export class FinscanOpportunityDto implements IFinscanOpportunityDto {
    constructor(
        public id?: string,
        public finscanEntity?: string,
        public finscanEntityName?: string,
        public enableContinuousMonitoring?: boolean,
        public enableAdHocMonitoring?:boolean,
        public enableSanctionScreening?:boolean,
    ) {
       this.enableContinuousMonitoring= false;
       this.enableAdHocMonitoring =false;
        this.enableSanctionScreening=false;
        
        if(finscanEntity!=null&&finscanEntity!=undefined) {
            this.finscanEntityName = FinscanOpportunityDto.getFinscanEntityName(finscanEntity);
        }
    }

    public static getFinscanEntityName(finscanEntity): string {
        switch(finscanEntity) {
            case FinscanEntity.POLICY_HOLDER:
                return 'Policy Holder';
            case FinscanEntity.FREIGHT_FORWARDER_CLIENT:
                return 'Freight Forwarder Client';
            case FinscanEntity.LOSS_PAYEE_BANK:
                return 'Loss Payee Bank';
            case FinscanEntity.LOSS_PAYEE_OTHER:
                return 'Loss Payee Other';
            case FinscanEntity.SURVEY_AGENTS:
                return 'Survey Agents';
            case FinscanEntity.VESSELS:
                return 'Vessels';
            case FinscanEntity.STORAGES:
                    return 'Storages';
        }
    }

    public static getFinscanEntityNameForSubRule(rulename) {
        switch(rulename) {
            case 'Client':
                return FinscanEntity.POLICY_HOLDER;
            case 'Freight Forwarder Client':
                return FinscanEntity.FREIGHT_FORWARDER_CLIENT;
            case 'Loss Payee Bank':
                return FinscanEntity.LOSS_PAYEE_BANK;
            case 'Loss Payee Other':
                return FinscanEntity.LOSS_PAYEE_OTHER;
            case 'Survey Agents':
                return FinscanEntity.SURVEY_AGENTS;
            case 'Vessels':
                return FinscanEntity.VESSELS;
        }
    }

}